/**重置message，防止重复点击重复弹出message弹框 */
import {
  Message
} from 'element-ui';
let messageInstance = null;
const resetMessage = (options) => {
    if(messageInstance) {
      messageInstance.close()
    }
    messageInstance = Message(options)
  }
;['error','success','info','warning','alert'].forEach(type => {
  resetMessage[type] = options => {
    console.log('options',options)
    if(typeof options === 'string') {
      options = {
        message:options
      }
      options.type = type
      return resetMessage(options)
    }
  }
})
export const message = resetMessage



// WEBPACK FOOTER //
// ./src/common/resetMessage.js